var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"btn-group action-button-group",attrs:{"role":"group"}},[_c('router-link',{staticClass:"btn btn-sm btn-success action-button-group--link",attrs:{"to":("/shops/" + _vm.id)}},[_vm._v("\n    show\n  ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }